import mammoth from 'mammoth';

/**
 * Fetches a DOCX file from a URL and converts it to ArrayBuffer
 * @param {string} url - The URL of the DOCX file
 * @returns {Promise<ArrayBuffer>} - The DOCX file as ArrayBuffer
 */
export const fetchDocxAsArrayBuffer = async (url) => {
  try {
    const response = await fetch(url, { cache: 'no-store', mode: 'cors' });

    if (!response.ok) {
      throw new Error(`Failed to fetch DOCX: ${response.status} ${response.statusText}`);
    }

    // Use blob first for more reliable binary handling
    const blob = await response.blob();
    const arrayBuffer = await blob.arrayBuffer();

    // Log if not DOCX (PK) - may be plain text instead
    const bytes = new Uint8Array(arrayBuffer);
    if (bytes.length >= 2 && bytes[0] !== 0x50 && bytes[1] !== 0x4b) {
      const preview = String.fromCharCode(...bytes.slice(0, 80)).replace(/[^\x20-\x7E]/g, '.');
      if (preview.trim().startsWith('<')) {
        throw new Error('Server returned an HTML page instead of a quiz file. Check the link.');
      }
    }
    return arrayBuffer;
  } catch (error) {
    console.error('Error fetching DOCX:', error);
    throw new Error(error.message || 'Failed to download quiz document. Please check the link and try again.');
  }
};
